module.exports = __webpack_public_path__ + "img/duo.48d965a9.jpg";